module.exports = __webpack_public_path__ + "img/no-results.9da5ab0b.svg";